import React from 'react'
import { Helmet } from 'react-helmet'
import { Content } from 'ui'
import * as Forms from '../Forms'

/**
 * The second step of the account creation process for a business professional.
 */
export const ProfessionalStepTwo: React.FC = () => (
  <Content.Region>
    <Helmet>
      <title>Create Account: Part 2 - MCSS PRO Connect</title>
    </Helmet>
    <Content.HeadingSmall>
      Part 2: Support &amp; Connection Preferences
    </Content.HeadingSmall>
    <Forms.ProfessionalStepTwo />
  </Content.Region>
)
